import { render, staticRenderFns } from "./CategoryDragDrop.vue?vue&type=template&id=28b5c83b&"
import script from "./CategoryDragDrop.vue?vue&type=script&lang=js&"
export * from "./CategoryDragDrop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports